const STATUSES = [
  {
    id: 'trial-status-new',
    value: 'New',
    order_key: 1,
    is_custom: false,
    color: '#3B82F6'
  },
  {
    id: 'trial-status-contacted',
    value: 'Contacted',
    order_key: 2,
    is_custom: false,
    color: '#F59E0B'
  },
  {
    id: 'trial-status-qualified',
    value: 'Qualified',
    order_key: 3,
    is_custom: false,
    color: '#8B5CF6'
  },
  {
    id: 'trial-status-negotiation',
    value: 'Negotiation',
    order_key: 4,
    is_custom: false,
    color: '#F97316'
  },
  {
    id: 'trial-status-won',
    value: 'Won',
    order_key: 5,
    is_custom: false,
    color: '#22C55E'
  }
];

const TAGS = [
  { id: 'trial-tag-001', name: 'Hot Lead', color: '#fbeab0' },
  { id: 'trial-tag-002', name: 'Referral', color: '#ccefe0' },
  { id: 'trial-tag-003', name: 'Walk-in', color: '#f2e6f2' },
  { id: 'trial-tag-004', name: 'Online', color: '#bad7ff' }
];

const AGENTS = [
  { user_id: 'trial-agent-001', name: 'Priya Nair' },
  { user_id: 'trial-agent-002', name: 'Rahul Verma' },
  { user_id: 'trial-agent-003', name: 'Sneha Iyer' }
];

const MOCK_LEADS = [
  {
    id: 'trial-lead-001',
    name: 'Aditya Menon',
    email_id: 'aditya.menon@example.com',
    country_code: '91',
    mobile_number: '9876500001',
    tags: [TAGS[0]],
    source: 'website',
    assignee: {
      id: AGENTS[0].user_id,
      name: AGENTS[0].name,
      profile_url: ''
    },
    status: {
      id: STATUSES[2].id,
      value: STATUSES[2].value,
      color: STATUSES[2].color
    },
    ad: null,
    is_onboarded: false
  },
  {
    id: 'trial-lead-002',
    name: 'Kavitha Reddy',
    email_id: 'kavitha.r@example.com',
    country_code: '91',
    mobile_number: '9876500002',
    tags: [TAGS[1]],
    source: 'referral',
    assignee: {
      id: AGENTS[1].user_id,
      name: AGENTS[1].name,
      profile_url: ''
    },
    status: {
      id: STATUSES[4].id,
      value: STATUSES[4].value,
      color: STATUSES[4].color
    },
    ad: null,
    is_onboarded: true
  },
  {
    id: 'trial-lead-003',
    name: 'Vikram Singh',
    email_id: 'vikram.s@example.com',
    country_code: '91',
    mobile_number: '9876500003',
    tags: [TAGS[2]],
    source: 'walk_in',
    assignee: {
      id: AGENTS[2].user_id,
      name: AGENTS[2].name,
      profile_url: ''
    },
    status: {
      id: STATUSES[0].id,
      value: STATUSES[0].value,
      color: STATUSES[0].color
    },
    ad: null,
    is_onboarded: false
  },
  {
    id: 'trial-lead-004',
    name: 'Deepa Sharma',
    email_id: 'deepa.sharma@example.com',
    country_code: '91',
    mobile_number: '9876500004',
    tags: [TAGS[3], TAGS[0]],
    source: 'social_media',
    assignee: {
      id: AGENTS[0].user_id,
      name: AGENTS[0].name,
      profile_url: ''
    },
    status: {
      id: STATUSES[3].id,
      value: STATUSES[3].value,
      color: STATUSES[3].color
    },
    ad: null,
    is_onboarded: false,
    is_external_synced: true
  },
  {
    id: 'trial-lead-005',
    name: 'Arjun Patel',
    email_id: 'arjun.p@example.com',
    country_code: '91',
    mobile_number: '9876500005',
    tags: [TAGS[1]],
    source: 'referral',
    assignee: {
      id: AGENTS[1].user_id,
      name: AGENTS[1].name,
      profile_url: ''
    },
    status: {
      id: STATUSES[1].id,
      value: STATUSES[1].value,
      color: STATUSES[1].color
    },
    ad: null,
    is_onboarded: false
  },
  {
    id: 'trial-lead-006',
    name: 'Meera Krishnan',
    email_id: 'meera.k@example.com',
    country_code: '91',
    mobile_number: '9876500006',
    tags: [TAGS[2]],
    source: 'walk_in',
    assignee: {
      id: AGENTS[2].user_id,
      name: AGENTS[2].name,
      profile_url: ''
    },
    status: {
      id: STATUSES[4].id,
      value: STATUSES[4].value,
      color: STATUSES[4].color
    },
    ad: null,
    is_onboarded: true
  },
  {
    id: 'trial-lead-007',
    name: 'Rohan Gupta',
    email_id: 'rohan.g@example.com',
    country_code: '91',
    mobile_number: '9876500007',
    tags: [TAGS[0], TAGS[3]],
    source: 'website',
    assignee: {
      id: AGENTS[0].user_id,
      name: AGENTS[0].name,
      profile_url: ''
    },
    status: {
      id: STATUSES[0].id,
      value: STATUSES[0].value,
      color: STATUSES[0].color
    },
    ad: null,
    is_onboarded: false
  },
  {
    id: 'trial-lead-008',
    name: 'Anjali Das',
    email_id: 'anjali.d@example.com',
    country_code: '91',
    mobile_number: '9876500008',
    tags: [TAGS[1]],
    source: 'referral',
    assignee: {
      id: AGENTS[1].user_id,
      name: AGENTS[1].name,
      profile_url: ''
    },
    status: {
      id: STATUSES[1].id,
      value: STATUSES[1].value,
      color: STATUSES[1].color
    },
    ad: null,
    is_onboarded: false
  }
];

export const getLeadDashboardMock = () => ({
  totals: {
    leads: { current: 8, delta_pct: 15.2 },
    expected_revenue: { current: 24500000, delta_pct: 8.5 },
    conversion_rate: { current_pct: 25, delta_pct: 3.1 }
  },
  overall: STATUSES.map((s, idx) => {
    const counts = [2, 2, 1, 1, 2];
    const revenues = [0, 0, 500000, 800000, 2450000];
    return {
      status_id: s.id,
      display_name: s.value,
      color: s.color,
      order: s.order_key,
      is_terminal: idx === 4,
      lead_count: counts[idx],
      revenue: revenues[idx]
    };
  }),
  distributions: {
    sources: [
      { name: 'Website', count: 2, percentage: 25 },
      { name: 'Referral', count: 3, percentage: 37.5 },
      { name: 'Walk-in', count: 2, percentage: 25 },
      { name: 'Social Media', count: 1, percentage: 12.5 }
    ],
    locations: [
      { location: 'Bengaluru', count: 4 },
      { location: 'Chennai', count: 2 },
      { location: 'Mumbai', count: 1 },
      { location: 'Hyderabad', count: 1 }
    ]
  }
});

export const getLeadsStuckSummaryMock = () => ({
  count: 2,
  revenue_at_risk: '500000',
  most_affected_stage: {
    status_id: STATUSES[2].id,
    display_name: STATUSES[2].value,
    color: STATUSES[2].color,
    lead_count: 2
  }
});

export const getLostLeadSummaryMock = () => ({
  lost_leads: {
    count: 1,
    revenue: 300000,
    status_id: 'trial-status-lost'
  },
  most_affected_status: {
    status_id: 'trial-status-lost',
    display_name: 'Lost',
    color: '#EF4444',
    count: 1
  }
});

export const getLeadInsightsMock = () => ({
  unassigned_leads: { count: 1, revenue: 150000 },
  leads: { current: 8, delta_pct: 15.2 },
  expected_revenue: { current: 24500000, delta_pct: 8.5 },
  conversion_rate: { current_pct: 25, delta_pct: 3.1 },
  avg_time_to_close: { current_days: 12, delta_days: -2 },
  top_agent: { agent_name: AGENTS[0].name, converted: 2 },
  overdue_leads: {
    count: 1,
    delta_count: 1,
    revenue_at_risk: 800000,
    agents_count: 1
  }
});

export const getLeadAnalyticsConversionMock = () => {
  const counts = [8, 6, 4, 3, 2];
  const percentages = [100, 75, 50, 37, 25];
  const revenues = [0, 0, 500000, 800000, 2450000];
  return {
    statuses: STATUSES.map((s, idx) => ({
      status_id: s.id,
      display_name: s.value,
      color: s.color,
      order: s.order_key,
      is_terminal: idx === STATUSES.length - 1,
      lead_count: counts[idx],
      percentage: percentages[idx],
      revenue: revenues[idx],
      cumulative_count: counts[idx]
    }))
  };
};

export const getAgentsStatusSummaryMock = (page: number, pageSize: number) => ({
  headers: STATUSES.map((s) => ({
    status_id: s.id,
    display_name: s.value,
    color: s.color,
    order: s.order_key,
    is_terminal: s.order_key === 5
  })),
  rows: AGENTS.map((agent, idx) => ({
    agent_name: agent.name,
    by_status: STATUSES.map((s, sIdx) => {
      const grid = [
        [1, 0, 1, 0, 1],
        [1, 1, 0, 1, 0],
        [0, 1, 0, 0, 1]
      ];
      const revGrid = [
        [0, 0, 500000, 0, 1200000],
        [0, 0, 0, 800000, 0],
        [0, 0, 0, 0, 1250000]
      ];
      return {
        status_id: s.id,
        count: grid[idx][sIdx],
        revenue: revGrid[idx][sIdx]
      };
    })
  })),
  pagination: {
    page,
    page_size: pageSize,
    total_rows: 3,
    total_pages: 1
  }
});

export const getLeadListMock = (
  page: number,
  limit: number,
  search: string
) => {
  let filtered = MOCK_LEADS;
  if (search) {
    const q = search.toLowerCase();
    filtered = MOCK_LEADS.filter(
      (l) =>
        l.name.toLowerCase().includes(q) ||
        l.email_id.toLowerCase().includes(q) ||
        l.mobile_number.includes(q)
    );
  }

  const start = page * limit;
  const data = filtered.slice(start, start + limit);

  return {
    data,
    pagination: {
      page,
      limit,
      total_rows: filtered.length,
      last_page: start + limit >= filtered.length
    }
  };
};

export const getLeadStatusMock = () => STATUSES;

export const getLeadTagsMock = () => TAGS;

// Every source id referenced by MOCK_LEADS' `source` field must resolve
// here, so useLeadSources' byId/byName lookup can display a proper name
// instead of falling back to the raw id string.
export const getLeadSourcesMock = () => ({
  data: [
    { id: 'website', name: 'Website', is_system: true },
    { id: 'referral', name: 'Referral', is_system: true },
    { id: 'walk_in', name: 'Walk-in', is_system: false },
    { id: 'social_media', name: 'Social Media', is_system: false }
  ]
});

export const getSalesAgentsMock = () => ({
  sales_agents: AGENTS
});

export const getLeadConfigMock = () => ({
  auto_assignment: false,
  round_robin: false,
  sources: [
    { id: 'website', value: 'Website' },
    { id: 'referral', value: 'Referral' },
    { id: 'walk_in', value: 'Walk-in' },
    { id: 'social_media', value: 'Social Media' }
  ],
  categories: [],
  lead_ingestion_enabled: false
});

export const getLeadCategoriesMock = () => [
  { id: 'trial-lcat-001', value: 'General Enquiry' },
  { id: 'trial-lcat-002', value: 'Admission' },
  { id: 'trial-lcat-003', value: 'Course Info' }
];

export const getLeadActivitiesTasksMock = () => ({
  data: [],
  pagination: {
    page: 0,
    limit: 10,
    total_rows: 0,
    last_page: true
  }
});

export const getLeadActivitiesEventsMock = () => ({
  data: [],
  pagination: {
    page: 0,
    limit: 10,
    total_rows: 0,
    last_page: true
  }
});

export const getLeadIngestionProviderMock = () => [];

export const getLeadIngestionAdsMock = () => ({
  data: [],
  pagination: {
    page: 0,
    limit: 10,
    total_rows: 0,
    last_page: true
  }
});

export const getLeadCitiesMock = () => ({
  locations: ['Bengaluru', 'Chennai', 'Mumbai', 'Hyderabad'],
  pagination: {
    page: 0,
    limit: 50,
    total_rows: 4,
    last_page: true
  }
});

export const getGoogleStatusMock = () => ({
  is_connected: false,
  email: null
});

export const getUserOrgSettingsMock = () => ({
  calendar_enabled: false,
  conferencing_enabled: false
});

export const getLeadDetailMock = (leadId: string) => {
  const lead = MOCK_LEADS.find((l) => l.id === leadId) || MOCK_LEADS[0];
  return {
    ...lead,
    id: leadId,
    deal_value: 50000,
    priority: 'medium',
    documents: [],
    address: null,
    city: 'Bengaluru',
    notes_count: 0,
    created_at: '2026-05-01T10:00:00Z',
    updated_at: '2026-05-15T12:00:00Z'
  };
};

export const getLeadNotesMock = () => ({
  data: [],
  total_rows: 0,
  last_page: true,
  page: 0,
  limit: 10,
  length: 0
});

export const getLeadVoiceNotesMock = () => ({
  data: [],
  pagination: { page: 0, limit: 10, total_rows: 0, last_page: true }
});

export const getLeadTimelineMock = () => ({
  data: [],
  pagination: {
    page: 0,
    limit: 20,
    total_rows: 0,
    last_page: true
  }
});

export const getLeadCustomFieldsMock = () => ({
  custom_fields: [
    {
      key: 'approximately_how_many_students_do_you_currently_manage?',
      value: ['less_than_50']
    },
    { key: 'company name', value: ['zida institute'] },
    {
      key: 'which_category_best_describes_your_business?',
      value: ['educational_institutes_(schools,_preschools,_colleges)']
    }
  ]
});

export const getLeadActivitySubMock = () => ({
  data: [],
  pagination: {
    page: 0,
    limit: 10,
    total_rows: 0,
    last_page: true
  }
});
